import { createBrowserRouter, Navigate } from "react-router";
import { lazy } from "react";
import { AuthProvider } from "./contexts/AuthProvider";
import { AuthGuard } from "./components/AuthGuard";

const ErrorBoundary = lazy(() =>
  import("./components/ErrorBoundary").then(({ ErrorBoundary }) => ({
    default: ErrorBoundary,
  }))
);

const Home = lazy(() =>
  import("./pages/Home").then(({ Home }) => ({
    default: Home,
  }))
);

const CampaignDetail = lazy(() =>
  import("./pages/CampaignDetail").then(({ CampaignDetail }) => ({
    default: CampaignDetail,
  }))
);

const router = createBrowserRouter([
  {
    element: (
      <AuthProvider>
        <AuthGuard />
      </AuthProvider>
    ),
    errorElement: <ErrorBoundary />,
    children: [
      { path: "/", Component: Home },
      { path: "/campaigns/:campaignId", Component: CampaignDetail },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);

export { router };
